module.exports = __webpack_public_path__ + "live-join-cc8722ad.png";